module.exports = __webpack_public_path__ + "static/Gotham-Bold-5f75f8e79c7c851f18e8dc493e4e1c02.woff";